export const AcceptedFileExts = [
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.csv',
    '.txt',
    '.pdf',
    '.jpg',
    '.jpeg',
    '.tif',
    '.tiff',
    '.png',
    '.bmp',
    '.gif',
    '.rtf',
    '.numbers',
    '.pages'
]

export const AcceptedMimeTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'text/plain',
    'application/pdf',
    'image/jpeg',
    'image/jpeg',
    'image/tiff',
    'image/tiff',
    'image/png',
    'image/bmp',
    'image/gif',
    'application/rtf',
    'application/x-iwork-numbers-sffnumbers',
    'application/x-iwork-pages-sffpages'
]

export const SignedFileKeys = ['signed', 'signé']

export const NeededFileKeys = ['eaf', 'mr69', 'customer interview', 'tp1 prefile', 't1 prefile']

export const fileTypeWillOpen = (fileType) => {
    let ft = (fileType || '').toLowerCase()
    return ['.pdf', '.txt', '.jpg', '.jpeg', '.tif', '.tiff', '.png', '.bmp', '.gif'].includes(ft)
}

export const isRestrictedFile = (file) => {
    return (file?.uploaderName === 'H&R Block');
}

export const isSignedFile = (file) => {
    return SignedFileKeys.some(key => ((file || {}).fileName || '').includes(key))
}

export const isNeededFile = (file) => {
    return NeededFileKeys.some(key => ((file || {}).fileName.toLowerCase() || '').includes(key))
}